//biome-ignore-all lint/suspicious/noConsole: allow logging erros and event
import { useEffect } from 'react';
import { appendScript } from '../../helpers/append-script';
import type {
  EmbeddedService,
  HiddenPreChatFields,
} from '../../types/salesforce-bootstrap-embedded-service';

export type Init = Parameters<EmbeddedService['init']>;
export type Prechat = HiddenPreChatFields;
export type Settings = EmbeddedService['settings'];

const init = (
  initOptions: Init,
  settings: Settings,
  prechat: HiddenPreChatFields
) => {
  try {
    if (!window.embeddedservice_bootstrap) {
      return;
    }

    window.embeddedservice_bootstrap.settings.language = settings.language;

    window.addEventListener('onEmbeddedMessagingReady', () => {
      if (!window.embeddedservice_bootstrap) {
        return;
      }

      const chatDataContainer = document.querySelector('[data-chat]');
      if (chatDataContainer) {
        try {
          const memberData = JSON.parse(chatDataContainer.innerHTML);

          window.embeddedservice_bootstrap.prechatAPI.setVisiblePrechatFields({
            _firstName: {
              value: memberData.firstName,
              isEditableByEndUser: true,
            },
            _lastName: {
              value: memberData.lastName,
              isEditableByEndUser: true,
            },
            _email: {
              value: memberData.email,
              isEditableByEndUser: true,
            },
            MobilePhone: {
              value: memberData.mobile,
              isEditableByEndUser: true,
            },
          });
        } catch (err) {
          console.error('Error loading Embedded Messaging: ', err);
        }
      }
    });

    window.addEventListener('onEmbeddedMessagingReady', () => {
      if (!window.embeddedservice_bootstrap) {
        return;
      }
      console.log('Received the onEmbeddedMessagingReady event…');

      const chatDataContainer = document.querySelector('[data-chat]');
      if (chatDataContainer) {
        try {
          const memberData = JSON.parse(chatDataContainer.innerHTML);
          window.embeddedservice_bootstrap.prechatAPI.setHiddenPrechatFields({
            ...prechat,
            ExerpMemberId: memberData.id,
          });
        } catch (err) {
          console.error('Error loading Embedded Messaging: ', err);
        }
      } else {
        window.embeddedservice_bootstrap.prechatAPI.setHiddenPrechatFields(
          prechat
        );
      }
    });

    window.embeddedservice_bootstrap.init(...initOptions);
  } catch (err) {
    console.error('Error loading Embedded Messaging: ', err);
  }
};

export const useSalesforceMessaging = (
  src: string,
  initOptions: Init,
  settings: Settings,
  prechat: HiddenPreChatFields
) =>
  useEffect(() => {
    if (window.embeddedservice_bootstrap) {
      init(initOptions, settings, prechat);
    } else {
      appendScript(src, () => init(initOptions, settings, prechat));
    }
  }, []);
